<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-prologue element-with-heading" id="prologue">
<div class="heading heading-with-title heading-without-image" id="prologue-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Prologue</h1>
</div>
<h2 class="subtitle">September 1961</h2>
</div>
</div>
</div>
<div class="text" id="prologue-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">T</span>he woman leans over the girl and strokes the hair from her tear streaked face. She gently kisses her forehead, as she does the girl opens her eyes and stares straight at her; she is exhausted and then she remembers.</p>
<p class="subsq">“Where is my baby?” she asks.</p>
<p class="subsq">“I’m sorry darling, she died before she entered this world.”</p>
<p class="subsq">”I heard a cry.”</p>
<p class="subsq">“No, she is gone, God has her now.”</p>
<p class="subsq">“But Mama, I heard a cry, I heard my baby.”</p>
<p class="subsq">”Sleep now.”</p>
<p class="subsq">“I heard her,” she protests. “Mama, I heard my baby. Where is she? Please Mama.” The girl tries to rise, pushing her mother’s hands away from her. Her mother holds her firm, pushing her back into the bed, she nods at the nurse who swiftly injects the prone girl. “I heard her, I heard…”</p>
<p class="subsq">Sleep takes her.</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">He hears the crunching of tyres on the gravel, then headlights illuminate the room as a car sweeps along the drive. She is here. He goes out onto the veranda; watching, waiting. The rear door of the car opens and a woman gets out, she stands there looking at him for a moment, impassive, expressionless; she holds his gaze before turning back to the car. She reaches into the back seat, lifting out a basket. She walks toward him and hands the basket to him.</p>
<p class="subsq">“How is…?”</p>
<p class="subsq">Before he can finish his sentence the woman raises her hand putting one finger across his lips.</p>
<p class="subsq">“You will never speak her name. You will never see her. You will never touch her, ever again. To you, she is gone, dead. From this moment on, my daughter is dead. Do you understand?”</p>
<p class="subsq">He nods his accord without speaking.</p>
<p class="subsq">The woman returns to the car pausing a moment before getting in then she turns and looks straight at him.</p>
<p class="subsq">“You are very lucky that I have not informed the authorities, but my daughter is still a child and I do not want her life blighted because of your sin. However, every action provokes a reaction, every deed spawns a consequence and that is yours,” she said, pointing at the basket. “I will be watching you, God will be watching you so do right by her and I pray that in her future she does not encounter a man like you.”</p>
<p class="subsq">He watched the car until its rear lights were no more than tiny red dots. As he turned to go back inside the house, something in the basket stirred.</p>
<p class="subsq">She was awake.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?101ca3e0